import { apiFetch } from "./client";

/**
 * Pregled saradnje sa kupcem, računat na serveru.
 *
 * Do 30.09.2026 je ovaj ekran stajao na izmišljenim brojevima, sa oznakom „demo podaci". Razlog je
 * bio dobar: portal nije imao ni fakturisano ni otvoreno, pa bi „prihod" bio broj porudžbina
 * pomnožen izmišljenom cenom. Sada oboje postoji.
 *
 * Ispunjenja prognoze nema, jer prognoza nema nijedan red. Bolje da ga nema nego da bude izmišljen.
 */

export type CooperationMonth = {
  month: number;
  orders: number;
  /**
   * Empty for a month after the day the outgoing invoices reach: it has no figures yet, which is not
   * a month without sales.
   */
  units: number | null;
  invoicedEur: number | null;
  /** Količina iste kalendarske mesece prethodne godine; prazno kad poređenje nije traženo. */
  prevYearUnits: number | null;
};

/**
 * One product line; `units` are kilograms. The row without a `line` is the remainder: the invoiced
 * figure less the lines above it, so the lines and the remainder add up to `invoicedEur`.
 */
export type CooperationLine = { line: string | null; units: number; eur: number };

/** Invoiced quantity in a unit other than the kilogram; `unit` is null when the line had none. */
export type CooperationUnit = { unit: string | null; quantity: number };

export type CooperationSnapshot = {
  year: number;
  orders: number;
  /** Promena broja porudžbina prema prethodnoj godini; prazno kad prethodne nema. */
  ordersDeltaPct: number | null;
  /** Kilograms invoiced in the year. */
  units: number;
  /** What was invoiced in other units, named next to the kilograms and never added to them. */
  otherUnits: CooperationUnit[];
  /** Invoiced in the year, VAT included: invoices only, without the opening balance. */
  invoicedEur: number;
  /** The opening balance posted in the year, left out of `invoicedEur`. */
  carriedPostedEur: number;
  /** Other debits posted in the year: reposts, rate differences, ledger orders. */
  otherPostedEur: number;
  /** Otvoreno na danas, ne godišnja veličina. */
  outstandingEur: number;
  monthly: CooperationMonth[];
  byLine: CooperationLine[];
};

export const cooperationApi = {
  snapshot: (companyId: string, year: number, compareYear?: number) => {
    const usp = new URLSearchParams({ year: String(year) });
    if (compareYear != null) usp.set("compareYear", String(compareYear));
    return apiFetch<CooperationSnapshot>(`/companies/${companyId}/cooperation?${usp}`);
  },
};
